import React, { createContext } from 'react'
import { defaultUserInfo, UserInfo } from '../services/Auth/UserInfo'

export { Capability } from '../services/Auth/UserInfo'
export const UserContext: React.Context<UserInfo> =
  createContext(defaultUserInfo)
